/**
 * LegacyInvoiceBanner Component
 *
 * Information banner displayed for invoices that were settled before
 * payment tracking was implemented. Warns users that adding payments
 * or credits will create a settlement record for audit purposes.
 *
 * User Story: US-REC-001 - Invoice Reconciliation
 */

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { InfoIcon } from 'lucide-react'

/**
 * LegacyInvoiceBanner displays an informational banner for legacy invoices
 * @param {Object} props - Component props
 * @param {string} props.className - Additional CSS classes
 * @param {boolean} props.compact - Show compact version without title (default: false)
 */
export function LegacyInvoiceBanner({ className, compact = false }) {
  if (compact) {
    return (
      <div
        className={`flex items-start gap-2 rounded-md border border-amber-200 bg-amber-50 p-3 text-sm text-amber-800 ${className || ''}`}
        role="alert"
      >
        <InfoIcon className="h-4 w-4 mt-0.5 shrink-0" aria-hidden="true" />
        <span>
          This invoice was settled before payment tracking was implemented.
        </span>
      </div>
    )
  }

  return (
    <Alert
      className={`border-amber-200 bg-amber-50 ${className || ''}`}
      role="alert"
    >
      <InfoIcon className="h-4 w-4 text-amber-600" aria-hidden="true" />
      <AlertTitle className="text-amber-800 font-medium">
        Legacy Invoice
      </AlertTitle>
      <AlertDescription className="text-amber-700">
        This invoice was settled before payment tracking was implemented.
        Adding payments or credits will create a settlement record for audit purposes.
      </AlertDescription>
    </Alert>
  )
}

export default LegacyInvoiceBanner
